module.exports = __webpack_public_path__ + "static/media/task-complete_white.d1d76402.svg";